import React from 'react';
import logo from '../../assets/images/logos/heraa-two-tone.png';

const AuthLayout = ({ eyebrow = 'Heraa Admin Portal', title, subtitle, children }) => (
  <main className="auth-page">
    <section className="auth-brand-panel" aria-hidden="true">
      <div className="auth-brand-glow auth-brand-glow-one" />
      <div className="auth-brand-glow auth-brand-glow-two" />
      <div className="auth-brand-content">
        <span className="auth-brand-kicker">Workforce intelligence</span>
        <h1>People operations,<br />beautifully connected.</h1>
        <p>A secure workspace designed to make every administrative task clearer, faster, and more human.</p>
        <div className="auth-brand-proof">
          <div><i className="fas fa-shield-alt" /><span>Trusted access</span></div>
          <div><i className="fas fa-chart-line" /><span>Actionable insights</span></div>
          <div><i className="fas fa-bolt" /><span>Efficient workflows</span></div>
        </div>
      </div>
    </section>
    <section className="auth-form-panel">
      <div className="auth-card">
        <img className="auth-logo" src={logo} alt="Heraa Solutions" />
        <div className="auth-heading">
          <span>{eyebrow}</span>
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children}
        <p className="auth-security-note"><i className="fas fa-lock" /> Secure access by Heraa Solutions</p>
      </div>
    </section>
  </main>
);

export default AuthLayout;
